const HELP_APPOINTMENTS: string = 'https://docorga.notion.site/Mes-rendez-vous-853ad5fc8e804f978f21d4d116c986b1';

const HELP_WAITING_LIST: string =
  'https://docorga.notion.site/Mes-dossiers-de-liste-d-attente-e050220c934c4c1d8b5abd3e996b0bb9';

const HELP_PATIENT: string =
  'https://docorga.notion.site/Bienvenue-sur-votre-FAQ-Docorga-0109566f2f3d4032854615e546a34e6a';

const HELP_DOCUMENTS_TO_PRACTITIONER: string =
  'https://docorga.notion.site/Transmettre-des-l-ments-compl-mentaires-mon-praticien-b52a2a1e7d984aee88878eb3fc443a46';

const HELP_NOT_ON_WAITLIST: string =
  'https://docorga.notion.site/Mon-praticien-m-indique-que-je-ne-suis-pas-inscrit-sur-sa-liste-d-attente-5d3613bca1274e79a825f127fa95d92e';

const HELP_WAITING_LIST_INSCRIPTION: string =
  'https://docorga.notion.site/S-inscrire-en-liste-d-attente-sur-Docorga-e1c1dae7ef3f42d7a7803689574b0e6d';

export const LINKS = {
  HELP_APPOINTMENTS,
  HELP_WAITING_LIST,
  HELP_PATIENT,
  HELP_DOCUMENTS_TO_PRACTITIONER,
  HELP_NOT_ON_WAITLIST,
  HELP_WAITING_LIST_INSCRIPTION
};
